























































import { Component, Vue } from 'vue-property-decorator';
import AddPenaltyRule from './modals/addPenaltyRule.vue';

   @Component({
      components:{AddPenaltyRule}
    })

export default class PenaltyRules extends Vue{

  isOpenModal:boolean=false;
  mockData:any[]=[];
  headers:any[]=[];
  breadcrumbsItems:any[]=[];


    created(){
      this.headers= [
          { text: 'Şirket',  align: 'start',filterable: false,   value: 'company', },
          { text: 'Uçuş Bölümü', value: 'segment' },
          { text: 'En Çok Gün Sayısı', value: 'maximumday' },
          { text: 'En Az Gün Sayısı', value: 'minimum day' },
          { text: 'Değer', value: 'value' },
          { text: "İşlemler", value: "transactions" }

        ],
        this.mockData=[
          {
            company: 'xxx',
            segment: 'xxx',
            maximumday: 'xxx',
            minimumday: 'xxx',
            value:'xxx',
          },

        ]

        this.breadcrumbsItems= [
          {text: 'Ana Sayfa',disabled: false,href: '/#/main/home'},
          {text: 'Tanımlamalar',disabled: true},
          {text: 'Ücret Kesinti Kuralları',disabled: true}
        
      ]

    }

    data () {
      return {
        page: 1,
      }

    }
    
    openModal(){
      this.isOpenModal=true;
    }
    closeModal(){
       this.isOpenModal = false;
    }
    
}




